import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'
import { Ziggy } from '@/modules/shared/helpers/facades/ziggy'

const ROUTE_PREFIX: string = 'panel.'

@vsingleton()
export class PanelUserRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'users.'

  index() {
    return Ziggy
      .route('panel.profile.index')
      .toString()
  }

  updateName() {
    return Ziggy
      .route('panel.profile.update.name')
      .toString()
  }

  updatePassword() {
    return Ziggy
      .route('panel.profile.update.password')
      .toString()
  }

  updateNotificationPreferences() {
    return Ziggy
      .route('panel.profile.update.notification_preferences')
      .toString()
  }

  updateBankAccount() {
    return Ziggy
      .route('panel.profile.update.bank_account')
      .toString()
  }

}
